import { Icon } from './Icon'
import { Row } from './Row'
import { Text } from './Text'
import { Color } from '../constants'

export type CompanyLogoProps = {
  displayName: string
  logoUrl?: string | null
  showIcon?: boolean
  size?: number
  small?: boolean
}

export const CompanyLogo = ({
  displayName,
  logoUrl,
  showIcon,
  size,
  small,
}: CompanyLogoProps) => {
  return logoUrl ? (
    <img alt={displayName} height={size ?? (small ? 24 : 32)} src={logoUrl} />
  ) : (
    <Row alignItems="center" gridGap={2} lineHeight={1.3}>
      {showIcon && (
        <Icon color={Color.BLUE} name="OfficeBuildingIcon" size="sm" />
      )}
      <Text bold color={Color.BLUE} my={1} size={6}>
        {displayName}
      </Text>
    </Row>
  )
}
